import { Button, Modal, rem } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { IconCheck } from "@tabler/icons-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { putPositions } from "./fetchPositions";
import { Position } from "../models";
import { useSettingsStorage } from "../ZustandState";

interface Props {
    opened: boolean;
    close: () => void;
    positions: Position[];
}

const SaveModal: React.FC<Props> = ({ opened, close, positions }) => {
    const navigate = useNavigate();
    const settings = useSettingsStorage((state) => state);

    const handleOnSave = async () => {
        const mappedPositions = positions.map((pos) => ({ ...pos, originalName: undefined }));
        const whitePositions = mappedPositions
            .filter((pos) => pos.defaultPlayerColor === "w")
            .map((pos, index) => ({ ...pos, index: index + 1 }));
        const blackPositions = mappedPositions
            .filter((pos) => pos.defaultPlayerColor === "b")
            .map((pos, index) => ({ ...pos, index: index + 1 }));
        const positionsToSend = [...whitePositions, ...blackPositions];
        await putPositions(positionsToSend, settings.startRating);
        navigate("/");
        notifications.show({
            title: "Changes saved",
            message: "",
            icon: <IconCheck style={{ width: rem(18), height: rem(18) }} />,
            color: "green",
        });
    };

    return (
        <Modal opened={opened} onClose={close} title="Do you want to save the changes?" centered padding={20}>
            <Button className="mt-6" color="green" h="3rem" onClick={handleOnSave} fullWidth>
                <span className="text-lg">Save changes</span>
            </Button>
            <Button
                className="mt-6"
                color="white"
                variant="outline"
                h="3rem"
                onClick={() => {
                    navigate("/");
                }}
                fullWidth
            >
                <span className="text-lg">Discard</span>
            </Button>
        </Modal>
    );
};

export default SaveModal;
